export const getUnsubscribePromptStyle = (theme) => ({
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '560px',
    textAlign: 'center',
});